import { API_ENDPOINTS, API_CONFIG, STORAGE_KEYS } from '../helpers/constants';

// Types for alerts API response
export interface TaskCountResponse {
  task_count: number;
}

export interface ApprovalCountResponse {
  approval_count: number;
}

export interface AlertCounts {
  tasks: number;
  approvals: number;
}

// Service for alerts/counts API calls
export const alertsService = {
  // Fetch task count
  async getTaskCount(): Promise<number> {
    try {
      // Get the bearer token from localStorage
      const token = localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN);
      
      if (!token) {
        console.warn('No auth token found for task count');
        return 0;
      }

      const response = await fetch(`${API_CONFIG.API_BASE_URL}${API_ENDPOINTS.TASKS.COUNT}`, {
        method: 'GET',
        headers: {
          'accept': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data: TaskCountResponse = await response.json();
      return data.task_count || 0;
    } catch (error) {
      console.error('Error fetching task count:', error);
      return 0;
    }
  },

  // Fetch approval count
  async getApprovalCount(): Promise<number> {
    try {
      // Get the bearer token from localStorage
      const token = localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN);
      
      if (!token) {
        console.warn('No auth token found for approval count');
        return 0;
      }

      const response = await fetch(`${API_CONFIG.API_BASE_URL}${API_ENDPOINTS.APPROVALS.COUNT}`, {
        method: 'GET',
        headers: {
          'accept': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data: ApprovalCountResponse = await response.json();
      return data.approval_count || 0;
    } catch (error) {
      console.error('Error fetching approval count:', error);
      return 0;
    }
  },

  // Fetch all alert counts at once
  async getAllAlertCounts(): Promise<AlertCounts> {
    try {
      const [taskCount, approvalCount] = await Promise.all([
        this.getTaskCount(),
        this.getApprovalCount(),
      ]);

      return {
        tasks: taskCount,
        approvals: approvalCount,
      };
    } catch (error) {
      console.error('Error fetching alert counts:', error);
      return {
        tasks: 0,
        approvals: 0,
      };
    }
  },
};

export default alertsService;

